$(document).ready(function () {
	var
		ua = navigator.userAgent.toLowerCase(),
		event = (ua.match(/Android/i) || ua.match(/iPad/i) || ua.match(/iPod/i) || ua.match(/iPhone/i)) ? "touchstart" : "click",
		isMobile = ua.match(/(iphone|ipod|ipad|android)/),
		window_w = $(window).width(),
		window_h = $(window).height(),
		is_home = $('body').hasClass('ishome');

	$.blockUI.defaults.message = LANG.aguarde;

	$.cookieBar({
		message: LANG.cookies_txt,
		acceptText: LANG.cookies_btn,
		fixed: true,
		bottom: true,
		policyButton: true,
		policyText: LANG.cp_txt,
		policyURL: LANG.cp_url,
	});

	$('html').removeClass('no-js');

	if (("standalone" in window.navigator) && window.navigator.standalone) {
		$('html').addClass('ios-standalone');
	}

	if ($.browser.msie) {
		$('html').addClass('is-ie');
		$('html').addClass('ie-' + $.browser.versionNumber);
	}

	if ($.browser.msedge) {
		$('html').addClass('is-edge');
	}

	if ($.browser.iphone && $.browser.safari) {
		$('html').addClass('ios-safari');
	}

	if ($.browser.iphone && $.browser.chrome) {
		$('html').addClass('ios-chrome');
	}

	if ($.browser.android && $.browser.chrome) {
		$('html').addClass('android-chrome');
	}

	/**
	 * Embed responsive
	 */
	var iframe = $('.text iframe');
	if (iframe.length) {
		iframe.wrap("<div class='embed'></div>");
	}

	/**
	 * Trigger AOS
	 */
	setTimeout(function () {
		/*$('#loader').fadeOut(500, function () {
			$(this).remove();
		});*/
		$('.loading-container').fadeOut();
		AOS.init({
			'offset': -50,
			disable: 'mobile'
		});
	}, 300);

	/**
	 * Fade loading images
	 */
	/*var load_images_bg = $('body').find('.load-img:not(.loaded), .load-img-uncover:not(.loaded)');
	if (load_images_bg.length) {
		load_images_bg.each(function (index, element) {
			var image = new Image(),
				$element = $(element),
				is_bg_or_img = typeof $element.data('src') !== 'undefined';

			image.onload = function () {
				if (is_bg_or_img) {
					$element.css("backgroundImage", "url('" + $element.attr("data-src") + "')").removeAttr('data-src');
				}
				setTimeout(function () {
					$element.parent().removeClass('loading');
					$element.addClass('loaded');
				}, 200);
			};
			image.src = is_bg_or_img ? $element.attr("data-src") : $element.find('img').attr('src');
		});
	}*/

	/**
	 * Lazy load images
	 */
	var velcroLazy = {
		/**
		 * init
		 * correr on load e sempre que for necessário, por exemplo, a seguir a uma call ajax
		 * elements: passar class dos ementos a fazer lazy load (ex: .lazy)
		 * ex: velcroLazy.init('.lazy');
		 */
		init: (elements) => {
			let lazyImages = $(elements);

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = $(entry.target),
								image = lazyImage.find('img')[0] || new Image(),
								is_bg_or_img = typeof lazyImage.data('src') !== 'undefined';

							image.onload = function () {
								if (is_bg_or_img) {//is bg
									lazyImage.css("backgroundImage", "url('" + lazyImage.data("src") + "')").removeAttr('data-src');
								}
								setTimeout(function () {
									lazyImage.addClass('loaded').removeClass("lazy").parent().removeClass('loading');
								}, 200);
							};

							image.src = is_bg_or_img ? lazyImage.data("src") : lazyImage.find('img').attr('data-src');
							lazyImageObserver.unobserve(entry.target);
						}
					});
				});

				lazyImages.each(function () {
					lazyImageObserver.observe(this);
				});
			} else {
				lazyImages.each(function () {
					var is_bg_or_img = typeof $(this).data('src') !== 'undefined';
					if (is_bg_or_img) {//is bg
						$(this).css("backgroundImage", "url('" + $(this).data("src") + "')").removeAttr('data-src');
					} else {//is img
						$(this).find('img').attr("src", $(this).find('img').data("src")).removeAttr('data-src');
					}
					$(this).addClass('loaded').removeClass("lazy").parent().removeClass('loading');
				});
			}
		}
	}

	velcroLazy.init('.lazy');

	var root = $('html,body');
	function smoothScrollingTo(target) {

		var target = $(target);
		if (target.length) {
			root.animate({
				scrollTop: target.offset().top - 100
			}, 400, "swing");
		}
	}

	$('a[href*=\\#]:not([href=\\#],[data-toggle],.open-popup)').on('click', function (event) {
		smoothScrollingTo(this.hash);
		if ($('.menu-mobile').hasClass('show')) {
			toogleMenu();
		}
	});

	smoothScrollingTo(location.hash);

	/**
	 * Exemplo de submissão de form
	 */
	$('body').on('click', '#send-suggestion', function (e) {
		e.preventDefault();

		var form = $('form.suggestion-form');
		var fields = form.serialize();
		var action = form.attr('action');

		if (checkPolicy(form)) {
			var send = true;
			form.find('#feedback__suggestion').removeClass().html('');
			form.find('.invalid').removeClass('invalid');

			if ($('#email').length) {
				var email = $('#email').val();
				if (!IsEmail(email)) {
					form.find('#email').parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.email_invalido).addClass('error').fadeIn("fast");
					send = false;
				}
			}

			var required = form.find('.required');
			required.each(function () {
				if ($.trim($(this).val()) == '' || $.trim($(this).val()) == $(this)[0].defaultValue) {
					$(this).parent().addClass('invalid');
					form.find('#feedback__suggestion').removeClass().html(LANG.preencha_os_campos_em_falta).addClass('error').fadeIn("fast");
					send = false;
				}
			});
			if (send) {
				$.blockUI();
				$.ajax({
					url: action,
					type: 'POST',
					data: fields,
					dataType: 'json',
					success: function (r) {
						if (r.class == 'ok') {
							form[0].reset();
						}
						$('#feedback__suggestion').show().addClass(r.class).html(r.message);
						$.unblockUI();
					},
					error: function (r) {
						$('#feedback__suggestion').show().addClass('error').html(LANG.email_erro);
						$.unblockUI();
					}
				});
			}
		} else {
			$('#feedback__suggestion').show().addClass('error').html(LANG.accept_privacy_policy);
			$.unblockUI();
		}
	});

	if (!Modernizr.objectfit) {
		$('body .objectfit').each(function () {
			var $container = $(this),
				imgUrl = $container.find('img').prop('src');
			if (imgUrl) {
				$container
					.css('backgroundImage', 'url(' + imgUrl + ')')
					.addClass('compat-object-fit');
			}
		});
	}

	/**
* Abrir e fechar o menu
*/
	$('#toggle-menu').on('click', function () {
		var el = $(this);
		if (el.hasClass('opened')) {
			el.removeClass('opened');
			$('#menu').removeClass('show');
			blockScroll(0);
		} else {
			el.addClass('opened');
			$('#menu').addClass('show');
			blockScroll(1);
		}
	});
	/**
 * Scroll do menu
 */
	windowOnScroll();
	$(window).on('scroll', function () {
		// compensateRellax();
		windowOnScroll();
		// fixReleaseTabs();
	});

	setTimeout(() => {
		if ($('.mh1').length) {
			$('.mh1').matchHeight(true);
		}
		if ($('.mh2').length) {
			$('.mh2').matchHeight(true);
		}
	}, 100);

	$('.homepage-slider').slick({
		arrows: false,
		fade: true,
		dots: true,
		draggable: false,
		autoplay: true,
		autoplaySpeed: 8000,
		infinite: true,
		pauseOnHover: true,
		pauseOnDotsHover: true,
		prevArrow: false,
		nextArrow: false,
		responsive: [
		]
	});
	// $('.milestones-slider').slick({
	// 	arrows: true,
	// 	dots: false,
	// 	draggable: true,
	// 	autoplay: false,
	// 	variableWidth: true,
	// 	infinite: false,
	// 	appendArrows: '.milestones-arrows',
	// 	responsive: [
	// 	]
	// });
	$('.governing-member').on('click', function () {
		var parent = $(this);
		var img = parent.find('.imagem1x1').css('background-image');
		var title = parent.find('.info-title').text();
		var job = parent.find('.position').text();
		var description = parent.find('.description').text();
		$('#board-popup').find('.imagem1x1').css('background-image', img);
		$('#board-popup').find('.info-title').text(title);
		$('#board-popup').find('.position').text(job);
		$('#board-popup').find('.popup-text').html(description);
		blockScroll(1);
		$('#board-popup').addClass('show');
	});
	$('.plus-btn.board-popup-btn').on('click', function () {
		var parent = $(this).parent().closest('.governing-member');
		var img = parent.find('.imagem1x1').css('background-image');
		var title = parent.find('.info-title').text();
		var job = parent.find('.position').text();
		var description = parent.find('.description').text();
		$('#board-popup').find('.imagem1x1').css('background-image', img);
		$('#board-popup').find('.info-title').text(title);
		$('#board-popup').find('.position').text(job);
		$('#board-popup').find('.popup-text').html(description);
		blockScroll(1);
		$('#board-popup').addClass('show');
	});
	$('.close-board-popup-btn').click('click', function () {
		$('#board-popup').removeClass('show');
		blockScroll(0);
		$('#board-popup').find('.imagem1x1').css('background-image', '');
		$('#board-popup').find('.info-title').empty();
		$('#board-popup').find('.position').empty();
		$('#board-popup').find('.popup-text').empty();
	});

	$("#categoria-select").change(function (e) {
		e.preventDefault();
		if (parseInt($("#categoria-select").val()) > 0)
			window.location.href = $(this).attr("rel") + "?category=" + $("#categoria-select").val() + '#blog-list';
		else
			window.location.href = $(this).attr("rel") + '#blog-list';
	});

	$("#events-categoria-select").change(function (e) {
		e.preventDefault();
		if (parseInt($("#events-categoria-select").val()) > 0) {
			var past_events = '';
			console.log($(this).attr("data-past-events"));
			if ($(this).attr("data-past-events") !== undefined && $(this).attr("data-past-events")) {
				past_events = '&past_events=1';
			}
			window.location.href = $(this).attr("rel") + "?category=" + $("#events-categoria-select").val() + past_events + '#events-list';
		}
		else {
			window.location.href = $(this).attr("rel") + '#events-list';
		}
	});
	var swiper_milestone = new Swiper(".milestones-slider", {
		// effect: "fade",
		// autoplay: {
		// 	delay: 5000,
		// },
		// fadeEffect: { // Add this
		// 	crossFade: true,
		// },
		slidesPerView: "auto",
		spaceBetween: 30,
		allowTouchMove: true,
		navigation: {
			nextEl: ".milestone-arrow-next",
			prevEl: ".milestone-arrow-prev",
		},
	});
	$('.input-group input[type="file"]').change(function (e) {
		$(this).siblings('span').text(e.target.files[0].name);
		if (!$(this).siblings('span').hasClass('file-uploaded')) {
			$(this).siblings('span').addClass('file-uploaded');
		}
	});


	if (!Modernizr.touchevents) {
		var stickyUser = $('#sticky-user');
		var sidebarUser;
		if (stickyUser.length) {
	
			sidebarUser = new StickySidebar('#sticky-user', {
				topSpacing: 150,
				bottomSpacing: 0,
				containerSelector: '#has-sticky',
				innerWrapperSelector: '#sticker-inner'
			});
	
			var targetUser = document.querySelector('#content');
	
			// create an observer instance
			var observerCheckout = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					if (mutation.type == 'childList') {
						sidebarUser.updateSticky();
					}
				});
			});
	
			// pass in the target node, as well as the observer options
			observerCheckout.observe(targetUser, {
				attributes: true,
				childList: true,
				subtree: true
			});
		}
	}

	if($('#accordion').length){
		if(!window.location.hash){
			$("#accordion-span-default").addClass('down');
			$("#accordion-desc-default").show();
		}
		$('#accordion').find('.accordion-visible-block').on('click', function(){
			
			if($(this).find('.accordion-arrow.down').length){
				$(this).parents('.accordion-title').removeClass('open');
				$(this).find('.accordion-arrow.down').removeClass('down');
				$(this).parents('.accordion-title').find('.accordion-desc').slideUp(200);
				$.bbq.pushState("#close");
			}else{
				$.bbq.pushState("#" + $(this).attr("data-url"));
			}
			});
		
		$(window).bind("hashchange", function(event){
			
			var $target = $('#accordion-' + decodeURIComponent($.param.fragment()));

			if($target.length){
				$target.find('.accordion-desc').slideToggle(200, function(){
					$("body, html").stop().delay(100).animate({scrollTop: ($target.offset().top - 120)}, 400);
				});
				$('.accordion-title').not($target).removeClass('open');
				$target.toggleClass('open');
				var thisspan = $target.find('span');
				$('.accordion-title span').not(thisspan).removeClass('down');
				$(thisspan).toggleClass('down');
				$(".accordion-desc:visible").not($target.find('.accordion-desc')).slideUp(200);
			}


			
		}).trigger("hashchange");
    }

	$(document).on('click', '.more', function(e){
		e.preventDefault();
		$('.dropout.active').not($(this).parent()).removeClass('active');
		$(this).parent().toggleClass('active');
	});

	$(document).on("click", function(e){
        if(!$(e.target).hasClass('more')){
			$('.dropout.active').removeClass('active');
        }            
    });

});



/**
 * Block scroll
 * @param block
 */
function blockScroll(block) {
	if (block == 1) {
		$('html').addClass('block-scroll');
	} else if (block == 0) {
		$('html').removeClass('block-scroll');
	}
}

/**
 * Verificar se é um email válido
 */
function IsEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<a>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email) ? true : false;
}

/**
 * Verifica se a checkbox de política de privacidade está ou não seleccionada
 */
function checkPolicy(form) {
	var checked = form.find('input[name="checkpolicy[]"]:checked').length;
	if (checked === 1) {
		return true;
	}

	return false;
}

/**
 * Window on scroll
 */
function windowOnScroll() {
	if ($(window).scrollTop() > 45 && $('body').hasClass('big') && $('body').hasClass('should-big')) {
		$('.should-big').removeClass('big');
	} else if ($(window).scrollTop() <= 45 && !$('body').hasClass('big') && $('body').hasClass('should-big')) {
		$('.should-big').addClass('big');
	}
	if ($(window).scrollTop() > 45 && !$('body').hasClass('scrolled')) {
		$('body').addClass('scrolled');
	} else if ($(window).scrollTop() <= 45 && $('body').hasClass('scrolled')) {
		$('body').removeClass('scrolled');
	}
}

if($('#map').length){
	function initMap() 
    {
        var map = new google.maps.Map(document.getElementById("map"), {
            disableDefaultUI: true,
			center: defaultCenter,
            zoomControl: true,
            styles: [{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#80cbde"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#144b59"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#80cbde"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#80cbde"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#617980"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#617980"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#144b59"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"saturation":"-100"},{"lightness":"100"}]}]
        });

		// Creating a global infoWindow object that will be reused by all markers
		var infoWindow = new google.maps.InfoWindow();

		// Looping through the JSON data
		var markers = [];
		for (var i = 0, length = locations.length; i < length; i++) {
			var data = locations[i],
				latLng = new google.maps.LatLng(data.lat, data.lng);
	
			// Creating a marker and putting it on the map
			var marker = new google.maps.Marker({
				position: latLng,
				map: map,
				title: data.name,
				icon: "imagens/pin_location.svg"
			});

			markers.push(marker);
	
			(function(marker, data) {
	
				google.maps.event.addListener(marker, "click", function(e) {

					const address = data.address ? '<div class="title">Address</div><div class="text">'+data.address+'</div>' : '';
					const single = data.single != '' ? '<div class="link"><a href="'+data.single+'">More information</a></div>' : '';

					const contentString =
					'<div class="infowindow">' +
					'<div class="title">University</div>' +
					'<div class="text">'+data.name+'</div>' +
					'<div class="title">Country</div>' +
					'<div class="text">'+data.country+'</div>' +
					address +
					single +
					"</div>";
					infoWindow.setContent(contentString);
					infoWindow.open(map, marker);
				});
	
			})(marker, data);
	
		}

		var getGoogleClusterInlineSvg = function (color) {
			var encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-100 -100 40 200"><defs><g id="a" transform="rotate(45)"><path d="M0 47A47 47 0 0 0 47 0L62 0A62 62 0 0 1 0 62Z" fill-opacity="0.7"/><path d="M0 67A67 67 0 0 0 67 0L81 0A81 81 0 0 1 0 81Z" fill-opacity="0.5"/><path d="M0 86A86 86 0 0 0 86 0L100 0A100 100 0 0 1 0 100Z" fill-opacity="0.3"/></g></defs><g fill="' + color + '"><circle r="42"/><use xlink:href="#a"/><g transform="rotate(120)"><use xlink:href="#a"/></g><g transform="rotate(240)"><use xlink:href="#a"/></g></g></svg>');
	
			return ('data:image/svg+xml;base64,' + encoded);
		};

		var cluster_styles = [
			{
				width: 40,
				height: 40,
				url: getGoogleClusterInlineSvg('blue'),
				textColor: 'white',
				textSize: 12
			},
			{
				width: 50,
				height: 50,
				url: getGoogleClusterInlineSvg('violet'),
				textColor: 'white',
				textSize: 14
			},
			{
				width: 60,
				height: 60,
				url: getGoogleClusterInlineSvg('yellow'),
				textColor: 'white',
				textSize: 16
			}
			//up to 5
		];


		const renderer = 
        {
            render: ({ count, position }) =>
                new google.maps.Marker({
                    label: { text: String(count), color: "white", fontSize: "10px" },
                    position,
					icon: 'imagens/map_marker_cluster.svg',
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                }),
        };
        new markerClusterer.MarkerClusterer({ 
            markers: markers, 
            map: map,
            renderer: renderer
        });
        
        //create empty LatLngBounds object
        var bounds = new google.maps.LatLngBounds();
        for (i = 0; i < markers.length; i++) {  
            //extend the bounds to include each marker's position
            bounds.extend(markers[i].position);
        }
        //now fit the map to the newly inclusive bounds
        map.fitBounds(bounds);
    }
}